// ===========================================
// Public API Functions
// ===========================================
// API calls for public endpoints (no authentication required)

import axios from 'axios';
import { Country, COUNTRIES } from '../constants/countries';

const API_BASE = import.meta.env.VITE_API_URL?.replace('/api/v1', '') || 'http://localhost:5000';

// ===========================================
// COUNTRIES
// ===========================================

/**
 * Fetch list of supported countries with states/provinces
 * Used for address form dropdowns
 *
 * Defensive: if the response is not a JSON array (e.g. a misconfigured nginx
 * proxy serves index.html for /api/public/*, returning an HTML string), fall
 * back to the static COUNTRIES constant instead of handing a non-array to
 * callers — a non-array crashed the admin Locations page (countries.find).
 */
export async function getCountries(): Promise<Country[]> {
  const response = await axios.get<Country[]>(`${API_BASE}/api/public/countries`);
  return Array.isArray(response.data) ? response.data : COUNTRIES;
}

export const countriesApi = {
  getAll: getCountries,
};
